class Board {
    _item;

    constructor(item) {
        this._item = item || {};
    }

    get raw() {
        return this._item;
    }

    get key() {
        return this._item.boardId
    }
}

export default Board
